import axios from 'axios'
import {
  getCsrfToken,
  getSessionToken,
} from '@futures-platform/connectors/session'

const baseUrl = process.env.REACT_APP_SCENARIO_API_URL
const publicURL = process.env.REACT_APP_PUBLIC_URL
const searchURL = process.env.REACT_APP_SEARCH_API_URL
const contentServiceURL = process.env.REACT_APP_CONTENT_SERVICE_API_URL
const mediaURL = process.env.REACT_APP_MEDIA_API_URL
const SCENARIO_API_URL = process.env.REACT_APP_SCENARIO_SERVICE_API_URL

async function httpRequest(
  baseUrlParams,
  method,
  path,
  payload = null,
  headers = {},
) {
  return axios({
    method,
    url: `${baseUrlParams}/${path}`,
    headers: {
      'X-CSRF-Token': getCsrfToken(),
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getSessionToken()}`,
      ...headers,
    },
    withCredentials: true,
    data: payload || null,
  })
}

export const scenarioAPIs = {
  createNewScenarioSet: async (gid, payload) => {
    return await httpRequest(baseUrl, 'POST', `${gid}/scenario_set`, payload)
  },
  createNewNarrative: async (payload) => {
    return await httpRequest(baseUrl, 'POST', `narrative`, payload)
  },

  getNarratives: async (scenarioId) => {
    return await httpRequest(baseUrl, 'GET', `narrative/${scenarioId}`)
  },

  getScenarioSet: async (gid, scenarioSetId) => {
    return await httpRequest(
      SCENARIO_API_URL,
      'GET',
      `${gid}/scenario_set/${scenarioSetId}?archived=true`,
    )
  },
  checkUserEdited: async (gid, scenarioSetId, drivers) => {
    return await httpRequest(
      contentServiceURL,
      'GET',
      `doc/check-scenario-card/${gid}/${scenarioSetId}/${drivers[0]}/${drivers[1]}`,
    )
  },
  getScenarioCards: async (gid, scenarioSetId) => {
    return await httpRequest(
      publicURL,
      'GET',
      `content-service-api/doc/scenario-set/${gid}/${scenarioSetId}`,
    )
  },

  searchScenarios: async (payload) => {
    return await httpRequest(searchURL, 'POST', `scenario-card`, payload)
  },
  getGroupData: async (gid) => {
    return await httpRequest(
      publicURL,
      'GET',
      `api/v1.0/group?filter[id]=${gid}`,
    )
  },

  createScenarioCards: async (gid, payload) => {
    return await httpRequest(
      contentServiceURL,
      'POST',
      `doc/${gid}/scenario-card`,
      payload,
    )
  },

  upsertScenarioCard: async ({ gid, doc }) => {
    if (!!doc?.id) {
      return await httpRequest(
        contentServiceURL,
        'PATCH',
        `doc/${gid}/scenario-card`,
        doc,
      )
    } else {
      return await httpRequest(
        contentServiceURL,
        'POST',
        `doc/${gid}/scenario-card`,
        doc,
      )
    }
  },
  deleteScenarioCard: async ({ gid, scenarioId }) => {
    return await httpRequest(
      contentServiceURL,
      'DELETE',
      `doc/${gid}/scenario-card/${scenarioId}`,
    )
  },
  updateScenarioCards: async (gid, payload) => {
    return await httpRequest(
      contentServiceURL,
      'PATCH',
      `doc/${gid}/scenario-card`,
      payload,
    )
  },
  //add hidden phenomennon of radar
  storeImgToDb: async (gid, imgFile) => {
    return await httpRequest(
      mediaURL,
      'PUT',
      !!gid ? `file/${gid}/image` : `file/image`,
      imgFile,
      {
        'Content-Type': imgFile?.type || 'application/octet-stream',
      },
    )
  },
}
